/* ==========================================================================
   POZER — B2B katalog (samostalni JS, bez frameworka)
   Fajl: assets/pozer-b2b.js
   ========================================================================== */
(function () {
  "use strict";

  function init(root) {
    if (!root || root.dataset.pzReady === "1") return;
    root.dataset.pzReady = "1";

    var palettes = window.pozerPalettes || {};

    /* ---------- galerija na karticama ---------- */
    root.addEventListener("mouseover", onThumb, true);
    root.addEventListener("click", onThumbClick, true);

    function activate(card, index) {
      var photos = card.querySelectorAll(".pz-photo");
      var thumbs = card.querySelectorAll(".pz-thumb");
      for (var i = 0; i < photos.length; i++) {
        photos[i].classList.toggle("is-active", i === index);
      }
      for (var t = 0; t < thumbs.length; t++) {
        thumbs[t].classList.toggle("is-active", t === index);
        thumbs[t].setAttribute("aria-current", t === index ? "true" : "false");
      }
    }

    function onThumb(event) {
      var thumb = event.target.closest ? event.target.closest(".pz-thumb") : null;
      if (!thumb) return;
      activate(thumb.closest(".pz-card"), parseInt(thumb.dataset.index, 10) || 0);
    }

    function onThumbClick(event) {
      var thumb = event.target.closest ? event.target.closest(".pz-thumb") : null;
      if (!thumb) return;
      event.preventDefault();
      activate(thumb.closest(".pz-card"), parseInt(thumb.dataset.index, 10) || 0);
    }

    /* ---------- pretraga + filtar kategorija ---------- */
    var searchInput = root.querySelector("#pz-search");
    var chips = root.querySelectorAll(".pz-chip");
    var cards = root.querySelectorAll(".pz-card");
    var empty = root.querySelector("#pz-empty");
    var activeCategory = "all";

    function applyFilters() {
      var q = searchInput ? searchInput.value.trim().toLowerCase() : "";
      var visible = 0;
      for (var i = 0; i < cards.length; i++) {
        var card = cards[i];
        var okCategory = activeCategory === "all" || card.dataset.category === activeCategory;
        var okQuery = !q || (card.dataset.search || "").indexOf(q) !== -1;
        var show = okCategory && okQuery;
        card.hidden = !show;
        if (show) visible++;
      }
      if (empty) empty.hidden = visible !== 0;
    }

    if (searchInput) searchInput.addEventListener("input", applyFilters);

    for (var c = 0; c < chips.length; c++) {
      chips[c].addEventListener("click", function () {
        activeCategory = this.dataset.filter || "all";
        for (var k = 0; k < chips.length; k++) {
          chips[k].classList.toggle("is-active", chips[k] === this);
        }
        applyFilters();
      });
    }

    /* ---------- modal za upit ---------- */
    var modal = root.querySelector("#pz-modal");
    var desc = root.querySelector("#pz-modal-desc");
    var fieldProduct = root.querySelector("#pz-field-product");
    var fieldSku = root.querySelector("#pz-field-sku");
    var colorSelect = root.querySelector("#pz-color");
    var colorText = root.querySelector("#pz-color-text");
    var form = root.querySelector("#pz-form");
    var lastTrigger = null;

    function fillColors(sku) {
      if (!colorSelect || !colorText) return;
      var list = palettes[sku] || [];
      colorSelect.innerHTML = '<option value="">Odaberite boju</option>';
      if (!list.length) {
        colorSelect.hidden = true;
        colorSelect.disabled = true;
        colorText.hidden = false;
        colorText.disabled = false;
        return;
      }
      colorText.hidden = true;
      colorText.disabled = true;
      colorSelect.hidden = false;
      colorSelect.disabled = false;
      for (var i = 0; i < list.length; i++) {
        var opt = document.createElement("option");
        opt.value = list[i];
        opt.textContent = list[i];
        colorSelect.appendChild(opt);
      }
    }

    function openModal(name, sku, trigger) {
      if (!modal) return;
      lastTrigger = trigger || null;
      if (fieldProduct) fieldProduct.value = name || "Opći upit — B2B ponuda";
      if (fieldSku) fieldSku.value = sku || "OPĆI UPIT";
      if (desc) {
        desc.textContent = name && sku
          ? name + " (šifra " + sku + ")"
          : "Ostavite nam podatke i pripremit ćemo ponudu za odabrane modele.";
      }
      fillColors(sku);
      modal.hidden = false;
      document.body.classList.add("pz-modal-open");
      var first = modal.querySelector("#pz-quantity");
      if (first) first.focus();
    }

    function closeModal() {
      if (!modal) return;
      modal.hidden = true;
      document.body.classList.remove("pz-modal-open");
      if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
    }

    root.addEventListener("click", function (event) {
      var btn = event.target.closest ? event.target.closest(".pz-inquiry") : null;
      if (btn) {
        event.preventDefault();
        openModal(btn.getAttribute("data-product"), btn.getAttribute("data-sku"), btn);
        return;
      }
      if (event.target.closest && event.target.closest("[data-pz-close]")) {
        event.preventDefault();
        closeModal();
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && modal && !modal.hidden) closeModal();
    });

    /* ---------- validacija obrasca ----------
       Bez backenda: prikazuje potvrdu. Kada obrazac zamijenite Shopify
       {% form 'contact' %}, obrišite ovaj submit handler — Shopify preuzima slanje.
    ------------------------------------------------------------------------- */
    

    applyFilters();
  }

  function boot() {
    var roots = document.querySelectorAll(".pz-root");
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  // Shopify theme editor
  document.addEventListener("shopify:section:load", boot);
})();
